import { isNil } from 'lodash';

import { defaultWorkerPermissions } from '../default-worker-permissions';
import type { WorkerPermissionsEditorOutput } from '../worker-permissions-editor-output';
import type { WorkerPermissionsFormType } from '../worker-permissions-form-type';

export const workerPermissionsToFormType = (
  workerPermissions: WorkerPermissionsEditorOutput,
): WorkerPermissionsFormType | undefined => {
  if (isNil(workerPermissions) || isNil(workerPermissions.join)) {
    return defaultWorkerPermissions;
  }

  return {
    join: workerPermissions.join,
  };
};
